<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm" (ngSubmit)="canInvite(f)">
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_INVITE_USER'"></h5>
  </div>
  <div class="modal-body modal-centered" tabindex="-1">
    <div class="form-group">
      <xrx-input
        type="text"
        id="email"
        name="email"
        [(ngModel)]="email"
        [maxlength]="1024"
        (keyup)="onKeyup()"
        placeholder="SDE_EMAIL2"
        [autofocus]="true"
        error="{{ error }}"
        label="SDE_EMAIL2"></xrx-input>
      <div><span [xdaTranslate]="'SDE_ENTER_EMAIL_ADDRESS24'"></span></div>
    </div>
    <br />
    <div class="form-group">
      <xrx-file-input
        [(ngModel)]="input.uploadFile"
        name="sourceFile"
        id="sourceFile"
        [fileTypesAccepted]="input.fileTypes.asAccept || ''"
        [fileTypesString]="input.fileTypes.asString || ''"
        (fileDropped)="handleUploadFileInput($event)"></xrx-file-input>
      <span
        [xdaTranslate]="'SDE_UPLOAD_CSV_FILE'"
        [formatValues]="maxEmails.toString()"></span>
    </div>
    <!-- select language -->
    <div class="form-group half-width" tabindex="-1">
      <xrx-select
        label="SDE_LANGUAGE"
        id="languages"
        [(list)]="languages"
        property="ISOCode"
        localize="SDE_KEY"
        [(selectedItem)]="selectedLanguage"></xrx-select>
    </div>
    @if (enablePrefill) {
      <div class="form-group ml-1">
        <xrx-checkbox
          label="SDE_PREFILL_MY_COMPANY"
          [(checkBoxValue)]="prefill"
          name="prefillCompany"></xrx-checkbox>
      </div>
    }
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button
        type="submit"
        class="xrx-btn btn-primary"
        [disabled]="
          !(
            (email && !input.uploadFile?.name) ||
            (input.uploadFile?.name && fileIsValid)
          ) || processing
        ">
        <span class="btn-label" [xdaTranslate]="'SDE_OK'"></span>
      </button>
    </div>
  </div>
</form>
